import { Persona } from "../model/persona";

export class EvadocInfoDto {
    uaa: number;
    docente: Persona;
    periodo: number;
}
